function getIsoFromTimestamp(timestampValue) {
  const timestamp = typeof timestampValue === 'string' ? Number(timestampValue) : timestampValue;

  return timestamp ? new Date(timestamp).toISOString() : undefined;
}

export default getIsoFromTimestamp;
